module.exports = __webpack_public_path__ + "img/checkimg.a8f51753.png";